module.exports = __webpack_public_path__ + "img/angststoerungen1_3000.c7ef64a3.webp";